var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdFMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31,20c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S33.2060547,20,31,20z M31,26 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S32.1025391,26,31,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,20c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S19.2060547,20,17,20z M17,26 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S18.1025391,26,17,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,18l-4,0.0019531V11c0-4.9628906-4.0371094-9-9-9h-3c-1.1025391,0-2,0.8974609-2,2v4h-4V4c0-1.1025391-0.8974609-2-2-2 h-3c-4.9628906,0-9,4.0371094-9,9v7H4c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h4v7 c0,4.9628906,4.0371094,9,9,9h3c1.1025391,0,2-0.8974609,2-2v-4h4v4c0,1.1025391,0.8974609,2,2,2h3c4.9628906,0,9-4.0371094,9-9v-7 h4c1.1025391,0,2-0.8974609,2-2v-8C46,18.8974609,45.1025391,18,44,18z M44,28h-4c-1.1025391,0-2,0.8974609-2,2v7 c0,3.859375-3.140625,7-7,7h-3v-4c0-1.1025391-0.8974609-2-2-2h-4c-1.1025391,0-2,0.8974609-2,2v4h-3c-3.859375,0-7-3.140625-7-7 v-7c0-1.1025391-0.8974609-2-2-2H4v-8h4c1.1025391,0,2-0.8974609,2-2v-7c0-3.859375,3.140625-7,7-7h3v4 c0,1.1025391,0.8974609,2,2,2h4c1.1025391,0,2-0.8974609,2-2V4h3c3.859375,0,7,3.140625,7,7v7c0,1.1025391,0.8974609,2,2,2h4V28z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdFMedium);
export default __webpack_public_path__ + "static/media/plug-household-f--medium.b3f97d42649add652dc344b3c217a564.svg";
export { ForwardRef as ReactComponent };